var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.253906,
    y: 1.04688,
    width: 111.272,
    height: 111.272,
    rx: 55.6362,
    transform: "rotate(-0.305768 -0.253906 1.04688)",
    fill: "#EBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCircle);
export default __webpack_public_path__ + "static/media/clock_circle.0a16948c95d9ecd77831c23b492ba661.svg";
export { ForwardRef as ReactComponent };